import { cn as e } from "../../lib/utils.es.js";
import { Button as t } from "../ui/button.es.js";
import { ArrowDownIcon as n, ArrowUpIcon as r, ChevronsUpDownIcon as i } from "lucide-react";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
// libs/ui-lib/src/components/DataTable/DataTableColumnHeader.tsx
function s({ column: s, title: c, className: l }) {
	if (!s.getCanSort()) return /* @__PURE__ */ a("span", {
		className: e("font-medium text-foreground text-sm leading-5", l),
		children: c
	});
	let u = s.getIsSorted(), d, f;
	return u === "asc" ? (d = r, f = "text-foreground") : u === "desc" ? (d = n, f = "text-foreground") : (d = i, f = "text-muted-foreground/60 group-hover:text-foreground"), /* @__PURE__ */ o(t, {
		type: "button",
		variant: "ghost",
		size: "sm",
		"aria-label": u === "asc" ? `${c}, sorted ascending` : u === "desc" ? `${c}, sorted descending` : `${c}, click to sort`,
		className: e("group inline-flex h-auto items-center justify-start gap-1 rounded-none px-0 py-0 font-medium text-foreground text-sm leading-5 hover:bg-transparent hover:text-foreground has-[>svg]:px-0", u && "text-foreground", l),
		onClick: () => s.toggleSorting(u === "asc"),
		children: [/* @__PURE__ */ a("span", { children: c }), /* @__PURE__ */ a(d, {
			className: e("h-3.5 w-3.5 shrink-0 transition-colors", f),
			"aria-hidden": "true"
		})]
	});
}
export { s as DataTableColumnHeader };
